import { connect } from 'react-redux'

import DriverKeyModal from '../../../pages/settings/components/Modals/DriverKeyModal'

import {
  assignToDriver,
  fetchKeys,
  getKeysMore,
  onSearchKeys,
  pageChangedKeys,
  resetConfig,
} from '../../../redux/configuration/actions'

import {
  getConfigSuccess,
  getErrorMessageConfig,
  getIsLoadingAssign,
  getKeys,
  getKeysCount,
  getKeysListIsLoading,
} from '../../../redux/configuration/selectors'

import {
  fetchParticipants,
  onSearch,
  pageChanged,
  resetParticipantConfig,
  getParticipantsMore,
  roleDriverFiltreChange,
} from '../../../redux/participants/actions'

import {
  getParticipants,
  getParticipantsCount,
  getParticipantsListIsLoading,
} from '../../../redux/participants/selectors'

const mapStateToProps = (state) => ({
  drivers: getParticipants(state),
  isLoadingDrivers: getParticipantsListIsLoading(state),
  driversCount: getParticipantsCount(state),
  keys: getKeys(state),
  isLoadingAssign: getIsLoadingAssign(state),
  success: getConfigSuccess(state),
  errorMessage: getErrorMessageConfig(state),
  isLoadingKeysList: getKeysListIsLoading(state),
  keysCount: getKeysCount(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchDrivers: () => {
    dispatch(onSearch(''))
    dispatch(roleDriverFiltreChange())
    dispatch(fetchParticipants())
  },

  searchDrivers: (search) => {
    dispatch(onSearch(search))
    dispatch(pageChanged(0))
    dispatch(fetchParticipants())
  },

  fetchMoreDrivers: (offset, search) => {
    dispatch(pageChanged(offset))
    dispatch(onSearch(search))
    dispatch(getParticipantsMore())
  },

  resetParticipant: () => dispatch(resetParticipantConfig()),

  fetchKeys: () => dispatch(fetchKeys()),
  searchKeys: (search) => {
    dispatch(onSearchKeys(search))
    dispatch(pageChangedKeys(0))
    dispatch(fetchKeys())
  },
  fetchMoreKeys: (offset) => {
    dispatch(pageChangedKeys(offset))
    dispatch(getKeysMore())
  },
  resetConfig: () => dispatch(resetConfig()),
  assign: (data) => dispatch(assignToDriver(data)),
})

export default connect(mapStateToProps, mapDisptachToProps)(DriverKeyModal)
